export default __webpack_public_path__ + "static/media/hollow_white.0b35cccc.svg";